/**
 * OCR & Label Printing API Client
 * Epic 70: Okmanvolvasó & Zebra Cimke
 */

import { api } from './client';

// ============================================
// TYPES
// ============================================

export interface OcrResult {
  name: string;
  dateOfBirth?: string;
  documentNumber: string;
  expiryDate?: string;
  nationality?: string;
  rawData?: Record<string, string>;
  confidence: number;
}

export interface OcrScanResult {
  id: string;
  tenantId: string;
  ocrResult: OcrResult;
  isExpired: boolean;
  isDuplicate: boolean;
  existingPartnerId?: string;
  existingPartnerName?: string;
  createdAt: string;
}

export interface ZebraLabelInput {
  productName: string;
  barcode: string;
  price: number;
  sku?: string;
}

export interface ZebraLabelResult {
  zpl: string;
  format: string;
  width: number;
  height: number;
}

export interface BrotherLabelInput {
  productName: string;
  price: number;
  vatRate: number;
  barcode?: string;
  category?: string;
}

export interface BrotherLabelResult {
  html: string;
  format: string;
  width: number;
  productName: string;
  grossPrice: number;
}

// ============================================
// API CALLS
// ============================================

export async function scanDocument(imageData: string) {
  return api.post<{ data: OcrScanResult }>('/ocr/scan', { imageData });
}

export async function getOcrResult(id: string) {
  return api.get<{ data: OcrScanResult }>(`/ocr/results/${id}`);
}

export async function generateZebraLabel(input: ZebraLabelInput) {
  return api.post<{ data: ZebraLabelResult }>('/labels/zebra', input);
}

export async function generateBrotherLabel(input: BrotherLabelInput) {
  return api.post<{ data: BrotherLabelResult }>('/labels/brother', input);
}
